import {ES_SEARCH_TYPES} from "src/constants/elastic-search";
import {
    BubbleEditInputTypes,
    TableMetadataInterface,
    TableColumnDefinition
} from "src/interfaces/server-side-table";

const domainColumnMetadata: TableColumnDefinition = {
    key: 'domain',
    dataType: ES_SEARCH_TYPES.KEYWORD,
    queryAble: true,
    sortAble: true,
    allowUpdateByUser: false,
    allowUpdateBySystem: true,
    uiFeatures: {
        visible: true,
        visibleName: "Domain",
        onTopFilter: false,
        visibleOnLoad: true
    }
}

const websiteIdColumnMetadata: TableColumnDefinition = {
    key: 'websiteId',
    queryAble: true,
    sortAble: true,
    dataType: ES_SEARCH_TYPES.KEYWORD,
    allowUpdateByUser: false,
    allowUpdateBySystem: true,
    uiFeatures: {
        visible: true,
        visibleName: "Website id",
        onTopFilter: false,
        visibleOnLoad: true
    }
}

export const programColumnMetadata: TableColumnDefinition = {
    key: 'program',
    dataType: ES_SEARCH_TYPES.KEYWORD,
    queryAble: true,
    sortAble: true,
    allowUpdateBySystem: true,
    allowUpdateByUser: false,
    uiFeatures: {
        visible: true,
        visibleName: "Program",
        onTopFilter: true,
        visibleOnLoad: true
    }
}

export const subProgramColumnMetadata: TableColumnDefinition = {
    key: 'subProgram',
    dataType: ES_SEARCH_TYPES.KEYWORD,
    queryAble: true,
    sortAble: true,
    allowUpdateBySystem: true,
    allowUpdateByUser: false,
    uiFeatures: {
        visible: true,
        visibleName: "Sub-Program",
        onTopFilter: false,
        visibleOnLoad: false
    }
}

export const targetedWebsiteColumnMetadata: TableColumnDefinition = {
    key: 'targetedWebsite',
    dataType: ES_SEARCH_TYPES.KEYWORD,
    queryAble: true,
    sortAble: true,
    allowUpdateBySystem: true,
    allowUpdateByUser: false,
    uiFeatures: {
        visible: true,
        visibleName: "Target Website",
        onTopFilter: true,
        visibleOnLoad: true
    }
}


export const workflowStatusColumnMetadata: TableColumnDefinition = {
    key: 'workflowStatus',
    dataType: ES_SEARCH_TYPES.KEYWORD,
    queryAble: true,
    sortAble: true,
    allowUpdateBySystem: true,
    allowUpdateByUser: false,
    uiFeatures: {
        visible: true,
        visibleName: "Workflow Status",
        onTopFilter: false,
        visibleOnLoad: true
    }
}

const errorColumnMetadata: TableColumnDefinition = {
    key: 'error',
    dataType: ES_SEARCH_TYPES.TEXT,
    queryAble: true,
    sortAble: true,
    allowUpdateBySystem: true,
    allowUpdateByUser: false,
    uiFeatures: {
        visible: true,
        visibleName: "Error",
        onTopFilter: false,
        visibleOnLoad: false
    }
}

const errorCauseColumnMetadata: TableColumnDefinition = {
    key: 'errorCause',
    dataType: ES_SEARCH_TYPES.TEXT,
    queryAble: true,
    sortAble: true,
    allowUpdateBySystem: true,
    allowUpdateByUser: false,
    uiFeatures: {
        visible: true,
        visibleName: "Error Cause",
        onTopFilter: false,
        visibleOnLoad: false
    }
}

const crawlJobIdColumnMetadata: TableColumnDefinition = {
    key: 'crawlJobId',
    dataType: ES_SEARCH_TYPES.KEYWORD,
    queryAble: true,
    sortAble: true,
    allowUpdateBySystem: true,
    allowUpdateByUser: false,
    uiFeatures: {
        visible: true,
        visibleName: "Crawl Job Id",
        onTopFilter: false,
        visibleOnLoad: true
    }
}

const crawlStartDateColumnMetadata: TableColumnDefinition = {
    key: 'crawlStartDate',
    dataType: ES_SEARCH_TYPES.DATE,
    queryAble: true,
    sortAble: true,
    allowUpdateBySystem: true,
    allowUpdateByUser: false,
    uiFeatures: {
        visible: true,
        visibleName: "Crawl Start Date",
        onTopFilter: false,
        visibleOnLoad: true
    }
}

const crawlEndDateColumnMetadata: TableColumnDefinition = {
    key: 'crawlEndDate',
    dataType: ES_SEARCH_TYPES.DATE,
    queryAble: true,
    sortAble: true,
    allowUpdateBySystem: true,
    allowUpdateByUser: false,
    uiFeatures: {
        visible: true,
        visibleName: "Crawl End Date",
        onTopFilter: false,
        visibleOnLoad: true
    }
}

const sporcEndDateColumnMetadata: TableColumnDefinition = {
    key: 'sporcEndDate',
    dataType: ES_SEARCH_TYPES.DATE,
    queryAble: true,
    sortAble: true,
    allowUpdateBySystem: true,
    allowUpdateByUser: false,
    uiFeatures: {
        visible: true,
        visibleName: "Sporc End Date",
        onTopFilter: false,
        visibleOnLoad: true
    }
}

const scraperPlannerEndDateColumnMetadata: TableColumnDefinition = {
    key: 'scraperPlannerEndDate',
    dataType: ES_SEARCH_TYPES.DATE,
    queryAble: true,
    sortAble: true,
    allowUpdateBySystem: true,
    allowUpdateByUser: false,
    uiFeatures: {
        visible: true,
        visibleName: "Scrape Planner End Date",
        onTopFilter: false,
        visibleOnLoad: true
    }
}

const assigneeColumnMetadata: TableColumnDefinition = {
    key: 'assignee',
    dataType: ES_SEARCH_TYPES.TEXT,
    queryAble: true,
    sortAble: true,
    allowUpdateBySystem: true,
    allowUpdateByUser: true,
    uiFeatures: {
        visible: true,
        visibleName: "Assignee",
        onTopFilter: false,
        visibleOnLoad: true
    }
}

const workflowIdColumnMetadata: TableColumnDefinition = {
    key: 'workflowId',
    dataType: ES_SEARCH_TYPES.KEYWORD,
    queryAble: true,
    sortAble: true,
    allowUpdateBySystem: true,
    allowUpdateByUser: false,
    uiFeatures: {
        visible: true,
        visibleName: "Workflow Id",
        onTopFilter: false,
        visibleOnLoad: false
    }
}

const workflowStartDateColumnMetadata: TableColumnDefinition = {
    key: 'workflowStartDate',
    dataType: ES_SEARCH_TYPES.DATE,
    queryAble: true,
    sortAble: true,
    allowUpdateBySystem: true,
    allowUpdateByUser: false,
    uiFeatures: {
        visible: true,
        visibleName: "Workflow Start Date",
        onTopFilter: true,
        visibleOnLoad: false
    }
}

const workflowEndDateColumnMetadata: TableColumnDefinition = {
    key: 'workflowEndDate',
    dataType: ES_SEARCH_TYPES.DATE,
    queryAble: true,
    sortAble: true,
    allowUpdateBySystem: true,
    allowUpdateByUser: false,
    uiFeatures: {
        visible: true,
        visibleName: "Workflow End Date",
        onTopFilter: false,
        visibleOnLoad: false
    }
}

const scraperPlannerJobIdColumnMetadata: TableColumnDefinition = {
    key: 'scraperPlannerJobId',
    dataType: ES_SEARCH_TYPES.KEYWORD,
    queryAble: true,
    sortAble: true,
    allowUpdateBySystem: true,
    allowUpdateByUser: false,
    uiFeatures: {
        visible: true,
        visibleName: "Scraper Planner Job Id",
        onTopFilter: false,
        visibleOnLoad: false
    }
}

const scraperPlannerStartDateColumnMetadata: TableColumnDefinition = {
    key: 'scraperPlannerStartDate',
    dataType: ES_SEARCH_TYPES.DATE,
    queryAble: true,
    sortAble: true,
    allowUpdateBySystem: true,
    allowUpdateByUser: false,
    uiFeatures: {
        visible: true,
        visibleName: "Scraper Planner Start Date",
        onTopFilter: false,
        visibleOnLoad: false
    }
}

const sporcJobIdColumnMetadata: TableColumnDefinition = {
    key: 'sporcJobId',
    dataType: ES_SEARCH_TYPES.KEYWORD,
    queryAble: true,
    sortAble: true,
    allowUpdateBySystem: true,
    allowUpdateByUser: false,
    uiFeatures: {
        visible: true,
        visibleName: "Sporc Job id",
        onTopFilter: false,
        visibleOnLoad: false
    }
}

const sporcStartDateColumnMetadata: TableColumnDefinition = {
    key: 'sporcStartDate',
    dataType: ES_SEARCH_TYPES.DATE,
    queryAble: true,
    sortAble: true,
    allowUpdateBySystem: true,
    allowUpdateByUser: false,
    uiFeatures: {
        visible: true,
        visibleName: "Sporc Start Date",
        onTopFilter: false,
        visibleOnLoad: false
    }
}

const pluginStatusColumnMetadata: TableColumnDefinition = {
    key: 'pluginStatus',
    dataType: ES_SEARCH_TYPES.KEYWORD,
    queryAble: true,
    sortAble: true,
    allowUpdateBySystem: true,
    allowUpdateByUser: false,
    uiFeatures: {
        visible: true,
        visibleName: "Plugin Status",
        onTopFilter: false,
        visibleOnLoad: true
    }
}

const recipeExecutionAttemptIdColumnMetadata: TableColumnDefinition = {
    key: 'recipeExecutionAttemptId',
    dataType: ES_SEARCH_TYPES.KEYWORD,
    queryAble: false,
    sortAble: true,
    allowUpdateBySystem: true,
    allowUpdateByUser: false,
    uiFeatures: {
        visible: false,
        visibleName: "Attempt id",
        onTopFilter: false,
        visibleOnLoad: false
    }
}

const startStepColumnMetadata: TableColumnDefinition = {
    key: 'startStep',
    dataType: ES_SEARCH_TYPES.KEYWORD,
    queryAble: true,
    sortAble: true,
    allowUpdateByUser: false,
    allowUpdateBySystem: true,
    uiFeatures: {
        visible: true,
        visibleName: "Start step",
        onTopFilter: false,
        visibleOnLoad: false
    }
}

const isRestartColumnMetadata: TableColumnDefinition = {
    key: 'isRestart',
    dataType: ES_SEARCH_TYPES.KEYWORD,
    queryAble: true,
    sortAble: true,
    allowUpdateByUser: false,
    allowUpdateBySystem: true,
    uiFeatures: {
        visible: true,
        visibleName: "Is Restart?",
        onTopFilter: false,
        visibleOnLoad: false
    }
}

const userCommentsColumnMetadata: TableColumnDefinition = {
    key: 'userComments',
    dataType: ES_SEARCH_TYPES.TEXT,
    queryAble: false,
    sortAble: false,
    allowUpdateByUser: true,
    allowUpdateBySystem: true,
    uiFeatures: {
        visible: true,
        visibleName: "Comments",
        onTopFilter: false,
        visibleOnLoad: true
    }
}

const crawlRouteTypeColumnMetadata: TableColumnDefinition = {
    key: 'crawlRouteType',
    dataType: ES_SEARCH_TYPES.KEYWORD,
    queryAble: true,
    sortAble: true,
    allowUpdateByUser: true,
    allowUpdateBySystem: true,
    uiFeatures: {
        visible: true,
        visibleName: "Crawl Route Type",
        onTopFilter: false,
        visibleOnLoad: false
    }
}

const failedWorkflowTypeColumnMetadata: TableColumnDefinition = {
    key: 'failedWorkflowType',
    dataType: ES_SEARCH_TYPES.KEYWORD,
    queryAble: true,
    sortAble: true,
    allowUpdateByUser: true,
    allowUpdateBySystem: true,
    uiFeatures: {
        visible: true,
        visibleName: "Failed Workflow Type",
        onTopFilter: false,
        visibleOnLoad: false,
    }
}

const scraperPtAttributeColumnMetadata: TableColumnDefinition = {
    key: 'scraperPtAttribute',
    dataType: ES_SEARCH_TYPES.KEYWORD,
    queryAble: true,
    sortAble: true,
    allowUpdateByUser: true,
    allowUpdateBySystem: true,
    uiFeatures: {
        visible: true,
        visibleName: "PT attribute Scraper",
        onTopFilter: false,
        visibleOnLoad: false
    }
}

/**
 * In future, Column Metadata will be provided by backend in json format.
 * We're hardcoding it for V0 release. Column order will be in same as this array.
 */
export const executionListTableMetadata: TableMetadataInterface = {
    // Workflow Context properties
    domain: domainColumnMetadata,
    websiteId: websiteIdColumnMetadata,
    program: programColumnMetadata,
    subProgram: subProgramColumnMetadata,
    targetedWebsite: targetedWebsiteColumnMetadata,

    // Attempt properties
    recipeExecutionAttemptId: recipeExecutionAttemptIdColumnMetadata,
    startStep: startStepColumnMetadata,
    isRestart: isRestartColumnMetadata,

    // Workflow related properties
    workflowId: workflowIdColumnMetadata,
    workflowStartDate: workflowStartDateColumnMetadata,
    workflowEndDate: workflowEndDateColumnMetadata,
    pluginStatus: pluginStatusColumnMetadata,
    workflowStatus: workflowStatusColumnMetadata,
    error: errorColumnMetadata,
    errorCause: errorCauseColumnMetadata,

    // Crawler related  properties
    crawlJobId: crawlJobIdColumnMetadata,
    crawlStartDate: crawlStartDateColumnMetadata,
    crawlEndDate: crawlEndDateColumnMetadata,
    crawlRouteType: crawlRouteTypeColumnMetadata,

    // Scraper related  properties
    scraperPlannerJobId: scraperPlannerJobIdColumnMetadata,
    scraperPlannerStartDate: scraperPlannerStartDateColumnMetadata,
    scraperPlannerEndDate: scraperPlannerEndDateColumnMetadata,
    assignee: assigneeColumnMetadata,
    scraperPtAttribute: scraperPtAttributeColumnMetadata,

    // Sporc related  properties
    sporcJobId: sporcJobIdColumnMetadata,
    sporcStartDate: sporcStartDateColumnMetadata,
    sporcEndDate: sporcEndDateColumnMetadata,

    // Misc
    userComments: userCommentsColumnMetadata,
    failedWorkflowType: failedWorkflowTypeColumnMetadata
}

const updateExecutionAttemptsTableProps = (columnProperties: TableColumnDefinition, visibleOnLoad: boolean, queryAble?: boolean)
    : TableColumnDefinition => {
    var columnDefinition: TableColumnDefinition = JSON.parse(JSON.stringify(columnProperties));
    columnDefinition.uiFeatures.visibleOnLoad = visibleOnLoad
    columnDefinition.allowUpdateByUser = false // No updates required on Attempts table.

    if (queryAble != undefined) {
        columnDefinition.queryAble = queryAble
    }
    return columnDefinition;
}

/**
 * Table metadata for execution attempts. Since columns names are same for execution list table and attempts table, we're
 * using same columns definition with changes needed for attempts table view. We can add/remove columns is it's irrelevant
 * to attempts table, but for execution list table.
 */
export const executionAttemptTableMetadata: TableMetadataInterface = {
    // Workflow Context. Since all Workflow context properties are going to be same for all attemps, we're hiding it on load.
    domain: updateExecutionAttemptsTableProps(domainColumnMetadata, false, false),
    websiteId: updateExecutionAttemptsTableProps(websiteIdColumnMetadata, false, false),
    program: updateExecutionAttemptsTableProps(programColumnMetadata, false, false),
    subProgram: updateExecutionAttemptsTableProps(subProgramColumnMetadata, false, false),
    targetedWebsite: updateExecutionAttemptsTableProps(targetedWebsiteColumnMetadata, false, false),

    // Attempt related properties
    recipeExecutionAttemptId: updateExecutionAttemptsTableProps(recipeExecutionAttemptIdColumnMetadata, true, true),
    startStep: updateExecutionAttemptsTableProps(startStepColumnMetadata, true, true),
    isRestart: updateExecutionAttemptsTableProps(isRestartColumnMetadata, true, true),

    // Workflow related properties.
    workflowId: {...updateExecutionAttemptsTableProps(workflowIdColumnMetadata, false, false),
        uiFeatures: {...updateExecutionAttemptsTableProps(workflowIdColumnMetadata, false, false).uiFeatures, visible: false}},
    workflowStartDate: updateExecutionAttemptsTableProps(workflowStartDateColumnMetadata, true, true),
    workflowEndDate: updateExecutionAttemptsTableProps(workflowEndDateColumnMetadata, true, true),
    pluginStatus: updateExecutionAttemptsTableProps(pluginStatusColumnMetadata, true, true),
    workflowStatus: updateExecutionAttemptsTableProps(workflowStatusColumnMetadata, true, true),
    error: updateExecutionAttemptsTableProps(errorColumnMetadata, true, true),
    errorCause: updateExecutionAttemptsTableProps(errorCauseColumnMetadata, true, true),

    // Crawler related properties
    crawlJobId: updateExecutionAttemptsTableProps(crawlJobIdColumnMetadata, true, true),
    crawlStartDate: updateExecutionAttemptsTableProps(crawlStartDateColumnMetadata, false, true),
    crawlEndDate: updateExecutionAttemptsTableProps(crawlEndDateColumnMetadata, false, true),

    // Scraper related properties
    scraperPlannerJobId: updateExecutionAttemptsTableProps(scraperPlannerJobIdColumnMetadata, true, true),
    scraperPlannerStartDate: updateExecutionAttemptsTableProps(scraperPlannerStartDateColumnMetadata, false, true),
    scraperPlannerEndDate: updateExecutionAttemptsTableProps(scraperPlannerEndDateColumnMetadata, false, true),
    assignee: updateExecutionAttemptsTableProps(assigneeColumnMetadata, false, true),

    // Sporc related properties
    sporcJobId: updateExecutionAttemptsTableProps(sporcJobIdColumnMetadata, true, true), // visible on load
    sporcStartDate: updateExecutionAttemptsTableProps(sporcStartDateColumnMetadata, false, true),
    sporcEndDate: updateExecutionAttemptsTableProps(sporcEndDateColumnMetadata, false, true)
}
